/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var iaw = iaw || { };

iaw.json = {
	/**
	 * Read and parse a JSON file from the local file system disk.
	 *
	 * @param path		string containing the full path to the file to process
	 * @return Processed JSON as an object or null.
	 */
	readLocalJSONFile: function(path) {

		var obj = null;

		if (window.__adobe_cep__ && path) {
			var result = window.cep.fs.readFile(path);

			if (0 === result.err) {
				try {
					obj = JSON.parse(result.data);
				}
				catch (error) {
					iaw.log.exception('Failed to read JSON file with path [' + path + '], error=' + error);
					obj = null;
				}
			}
			else if (3 === result.err) {
				iaw.log.console('Attempt to read JSON file failed, file does not exist [' + path + ']');
			}
			else {
				iaw.log.console('Attempt to read JSON file failed with path [' + path + '], error code=' + result.err);
			}
		}
		return obj;
	},

	/**
	 * Preprocess the JSON data common to all CCX extensions.
	 *
	 * @param key			data key name string
	 * @param val			key's value
	 * @return A possibly modified 'val' parameter.
	 */
	commonDataReceiver: function(key, val) {

		switch (key) {
			case 'userTrackingEnabled':
				if (typeof val === 'string') {
					val = (val === 'true' || val === '1');
				}
				iaw.analytics.enabled = val; // enable/disable analytics
				break;

			case 'fnftEnabled':
				if (typeof val === 'string') {
					val = (val === 'true' || val === '1');
				}
				break;

			case 'shortcut':
				val = val.replace(/Cmd\+/, '⌘');
				break;

			case 'language':
				// special case en_IL & en_AE to remap for en_US
				val =  (val !== 'en_IL' && val !== 'en_AE') ? val : 'en_US';
//				val = 'ja_JP';  // force Japanese
//				val = 'fr_FR';  // force French
//				val = 'de_DE';  // force German
				break;

		}
		return val;
	},

	/**
	 * Preprocess the JSON data specific for CCX-Start.
	 *
	 * @param key			data key name string
	 * @param val			key's value
	 * @return A possibly modified 'val' parameter.
	 */
	startDataReceiver: function(key, val) {

		switch (key) {
			case 'thumbnailViewEnabled':
			case 'listViewEnabled':
				if (typeof val === 'string') {
					val = (val === 'true' || val === '1');
				}
				break;

			case 'size':
				val = parseInt(val);
				break;

			case 'thumb':
				if (val) {
					// strip empty thumbnails
					if (val === 'data:image/jpeg;base64,') {
						val = '';
					}
					// strip newlines inserted by JSON.parse
					else {
						val = val.replace(/\n/g, '');
					}
				}
				break;

			case 'icon':
				if (val.indexOf('SP_Preset') < 0 && val.indexOf('SP_QuickStart') < 0) {
					switch (val) {
						case 'aep':
						case 'pr_proj_primary':
						case 'pr_convert_premiere_clip':
							val = 'CCX_Start_DefaultThumb_Pr_Ae';
							break;

						case 'ai':
						case 'psd':
						case 'id':
						case 'id_library':
						case 'id_book':
							val = 'CCX_Start_DefaultThumb_Ps_Ai_Id';
							break;

						default:
							val = 'CCX_Start_DefaultThumb_other';
							break;
					}
				}
				break;

			case 'dontShowAgain':
				if (typeof val === 'string') {
					val = (val === 'true' || val === '1');
				}
				break;

			case 'secondsLeftInTrial':
			case 'appStartClockTime':
				if (typeof val === 'string') {
					val = parseInt(val);
				}
				break;

			default:
				val = iaw.json.commonDataReceiver(key, val);
				break;
		}

		return val;
	},

	/**
	 * Preprocess the JSON data specific for CCX-FNFT.
	 *
	 * @param key			data key name string
	 * @param val			key's value
	 * @return A possibly modified 'val' parameter.
	 */
	fnftDataReceiver: function(key, val) {

		switch (key) {
			default:
				val = iaw.json.commonDataReceiver(key, val);
				break;
		}

		return val;
	}
};
